/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_PlaceholderInputs */

const en_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a preset`)
};

const fr_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un préréglage`)
};

const de_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung.`)
};

const it_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un preset`)
};

const ru_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку`)
};

const es_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija un ajuste preestablecido`)
};

const zh_cn2_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择预设`)
};

const ja_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択`)
};

const hi_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक प्रीसेट चुनें`)
};

const pt_pt2_subtitle_export_preset_load_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma predefinição`)
};

/**
* | output |
* | --- |
* | "Choose a preset" |
*
* @param {Subtitle_Export_Preset_Load_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_placeholder = /** @type {((inputs?: Subtitle_Export_Preset_Load_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "de") return de_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "it") return it_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "es") return es_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_load_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_load_placeholder(inputs)
	return en_subtitle_export_preset_load_placeholder(inputs)
});